import I18n from '@utils/i18n'

import { type ITimeType } from './constant'

let env = process.env.NEXT_PUBLIC_API_ENV
if (env !== 'pre' && env !== 'pre1' && env !== 'pro' && env !== 'prod') {
  env = 'beta'
}

/** 获取语言 */
const getLocale = (locale: string) => {
  let newLocale = 'en'
  switch (locale) {
    case 'zh-TC':
      newLocale = 'zh_TW'
      break;
    case 'zh-CN':
      newLocale = 'zh'
      break;
    default:
      newLocale = 'en';
      break;
  }
  return newLocale
}

/**
 * 获取 K线 的 iframe
 * @param timeType 时间间隔
 * @param coinCode 交易对
 * @param precision 精度
 * @param mainIndicator 主图
 * @param secondIndicator 副图
 * @returns
 */
export const getIframeHtml = (timeType: ITimeType, coinCode: string, precision: number, mainIndicator: string = '', secondIndicator: string = '') => {
  const host = 'https://upload.kikitrade.com/tradingview_dark_theme/index.html';
  const src = `${host}?env=${env}&lc=${getLocale(I18n.locale)}&ty=${timeType}&cc=${coinCode}&pc=${precision}&ms=${mainIndicator}&ss=${secondIndicator}&dsp=${coinCode}`;
  return `<iframe id="tradingViewIframe" class="tradingViewIframe"  scrolling="no" title="fx." src="${src}" frameborder="no" allowtransparency="true" allowfullscreen="true"></iframe>`;
}

export type getKLineValueRes = {
  activeTimeType?: string;
  activeSecondIndicator?: string[];
  activeMainIndicator?: string[];
}

export const getKLineValue = (): getKLineValueRes => {
  const klineValueStr = localStorage.getItem('klineValue');
  if (klineValueStr) {
    try {
      return JSON.parse(klineValueStr);
    } catch (error) { }
  }
  return {}
}

export const saveKLineValue = (params: getKLineValueRes) => {
  const klineValue = getKLineValue();
  localStorage.setItem('klineValue', JSON.stringify({ ...klineValue, ...params }));
}
